import fileUpload from "./file-upload";
import glsAdmin from "./gls-admin";

export default {
  fileUpload,
  glsAdmin,
};
